/**
 * QuikCoins a badge pays, by rarity - the backend's badge.<rarity> reward keys (RewardService). Shown in the badge
 * moment; the server is what actually pays, once per badge.
 */
const COINS_BY_RARITY = {
  common: 50,
  uncommon: 80,
  rare: 110,
  epic: 250,
  legendary: 500,
  mythic: 1000,
};

export function coinsForRarity(rarity) {
  return COINS_BY_RARITY[String(rarity || '').toLowerCase()] || 0;
}
